// Tamanho de fonte configurável por grade (botões A+/A-, persistido por usuário/grade — ver
// UsuarioController.TamanhoFonteGrid e Seguranca.obterDadosGrid).
//
// PROBLEMA QUE ISTO RESOLVE: todo container de grade declara `useState<number>(0)` e só depois
// preenche com `dados.TamanhoFonte`. Quando o usuário nunca configurou a fonte daquela grade, o
// valor que chega (ou que fica) é **0** — e `<tbody style={{ fontSize: 0 }}>` deixa TODO o texto
// da grade invisível (as linhas, ícones e inputs continuam aparecendo, só o texto some), o que
// parece "grade vazia" para o usuário.
//
// Os fallbacks que existiam antes não pegavam o caso `0`:
//   `tamanho.toString() + "px" || "13px"`  -> "0px" é string não-vazia, o || NUNCA dispara
//   `tamanho ?? 13`                        -> ?? só cobre null/undefined, não 0
//
// Usar SEMPRE este helper ao montar o `style` de uma grade, em vez de repetir o idioma.

// Devolve `undefined` quando não há tamanho válido, para que a propriedade `fontSize` simplesmente
// não seja emitida no inline style e o elemento herde o tamanho definido no CSS — em vez de forçar
// um número "chutado" aqui, que divergiria do CSS de cada tela.
export function fonteGradeOuHerdada(tamanho: number | null | undefined): number | undefined {
    return tamanho && tamanho > 0 ? tamanho : undefined
}

// Variante para os poucos lugares que montam a string CSS na mão (ex.: `fontSize: "13px"`).
export function fonteGradeEmPxOuPadrao(tamanho: number | null | undefined, padraoPx: number = 13): string {
    return `${tamanho && tamanho > 0 ? tamanho : padraoPx}px`
}
